import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";
import PhoneInput from "react-phone-input-2";
import { allIcons } from "../../../assets";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import ImageUploader from "../../../components/ImageUploader";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { createTeamValidation } from "../../../utils/Validation";

function AddNewMember(props) {
  const {
    handleChangeTab,
    inputValue,
    setInputValue,
    handleInputChange,
    allBranches,
    user,
    inputError,
    salaryOption,
    setSalaryOption,
    handleSnackbarVal,
    setInputError,
  } = props;

  const handleSaveAndNext = (row) => {
    const isValid = createTeamValidation(inputValue, setInputError);
    console.log("Validation Result:", isValid);

    if (!isValid) {
      console.log("Validation failed! Fix errors before proceeding.");
      return;
    }

    console.log("Validation passed! Proceeding to next step.");
    handleChangeTab(row);
    localStorage.setItem("team-form-data", JSON.stringify(inputValue));
  };

  const handleImageUpload = (url) => {
    setInputValue((prev) => ({
      ...prev,
      images: url,
    }));
    handleSnackbarVal(true, "success", "Image uploaded successfully");
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Save & Next"}
          handleClickBtn={() => handleSaveAndNext("assignedService")}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 130,
          }}
        />
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"Create new team member"}
      secondaryHeading={"Manage your team members personal & business profile."}
      headProps={renderRightPart()}
      showBackButton
      handleBack={() => handleChangeTab("teamMemebrs")}
      childrenProps={{
        sx: {
          padding: { xs: "10px 20px", md: "20px 50px" },
          paddingBottom: "50px !important",
        },
      }}
    >
      <Typography my={1} variant="h1" fontSize={"1.125rem"} fontWeight={600}>
        {/* Personal details */}
      </Typography>

      <ImageUploader
        image={inputValue?.images}
        onUploadSuccess={handleImageUpload}
        handleSnackbarVal={handleSnackbarVal}
      />
      {inputError?.images && (
        <Label labelText="Image is required" labelProps={{ color: "red" }} />
      )}
      {/* <ImageUploader
        image={inputValue?.images}
        setInputValue={setInputValue}
        handleSnackbarVal={handleSnackbarVal}
      /> */}

      <Grid container spacing={2} my={3}>
        <Grid item xs={12} md={4}>
          <Label labelText="First name" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"e.g kamran"}
            name="firstName"
            value={inputValue?.firstName}
            onChange={handleInputChange}
          />
          {inputError?.firstName && (
            <Label
              labelText="First name is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Last name" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"e.g qadeer"}
            name="lastName"
            value={inputValue?.lastName}
            onChange={handleInputChange}
          />
          {inputError?.lastName && (
            <Label
              labelText="Last name is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Email" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"e.g kamranqadeer@gmail.com"}
            name="email"
            value={inputValue?.email}
            onChange={handleInputChange}
          />
          {inputError?.email && (
            <Label
              labelText="Email is required"
              labelProps={{ color: "red" }}
            />
          )}
          {inputError?.isEmailValid && (
            <Label labelText="Enter a valid email" required />
          )}
        </Grid>
        <Grid item sm={12} md={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Label labelText="Contact number" required />
              <PhoneInput
                country={"us"}
                inputClass="cutom-phone-input-grey"
                buttonClass="custom-phone-input-button"
                value={inputValue?.contact}
                onChange={(phone) =>
                  setInputValue({ ...inputValue, contact: phone })
                }
              />
              {inputError?.contact && (
                <Label
                  labelText="Contact number is required"
                  labelProps={{ color: "red" }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <Label labelText="Job Title" required />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"Job Title"}
                name="jobTitle"
                value={inputValue?.jobTitle}
                onChange={handleInputChange}
              />
              {inputError?.jobTitle && (
                <Label
                  labelText="Job title is required"
                  labelProps={{ color: "red" }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={2}>
          <Label labelText="Gender" required />
          <CustomDropDown
            size={"small"}
            name="gender"
            value={inputValue?.gender}
            onChange={handleInputChange}
          >
            <MenuItem value={"Male"}>Male</MenuItem>
            <MenuItem value={"Female"}>Female</MenuItem>
          </CustomDropDown>
          {inputError?.gender && (
            <Label
              labelText="Gender is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
        <Grid item xs={12} md={10}>
          <Label labelText="Address" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"e.g Wah Cantt, Taxila, Rawalpindi, Pakistan"}
            name="address"
            value={inputValue?.address}
            onChange={handleInputChange}
          />
          {inputError?.address && (
            <Label
              labelText="Address is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
      </Grid>

      <Typography my={1} variant="h1" fontSize={"1.125rem"} fontWeight={600}>
        Employment details
      </Typography>

      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} md={2}>
          <Label labelText="Join Date" labelProps={{ fontWeight: 600 }} />
        </Grid>
        <Grid item xs={12} md={3}>
          <Label labelText="Start Date" />
          <DatePicker
            sx={globalStyle.textField}
            name="startDate"
            value={inputValue?.startDate ? inputValue?.startDate : null}
            onChange={(date) =>
              setInputValue({
                ...inputValue,
                startDate: date,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={0.5}>
          <Label labelText="To" />
        </Grid>
        <Grid item xs={12} md={3}>
          <Label labelText="End Date" />
          <DatePicker
            name="endDate"
            value={inputValue?.endDate ? inputValue?.endDate : null}
            sx={globalStyle.textField}
            onChange={(date) =>
              setInputValue({
                ...inputValue,
                endDate: date,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Branches" required />
          <CustomDropDown
            size={"small"}
            name="branchId"
            value={inputValue?.branchId}
            onChange={handleInputChange}
          >
            {allBranches.map((branch, index) => {
              return (
                <MenuItem key={index} value={branch._id}>
                  {branch?.displayName}
                </MenuItem>
              );
            })}
          </CustomDropDown>
          {inputError?.branchId && (
            <Label
              labelText="Branch is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
      </Grid>

      <Typography
        mt={3}
        mb={1}
        variant="h1"
        fontSize={"1.125rem"}
        fontWeight={600}
      >
        Salary Based
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Stack
            mb={1}
            gap={0.5}
            direction={"row"}
            alignItems={"center"}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setInputValue((prev) => ({
                ...prev,
                salaryType: "Percentage",
                salary: "",
              }));
              setSalaryOption({
                percentage: true,
                salary: false,
                both: false,
              });
            }}
          >
            <img
              width={20}
              src={
                salaryOption.percentage
                  ? allIcons.conformIcon
                  : allIcons.checkInactiveCircle
              }
              alt="icon"
            />
            <Label
              labelText="Percentage based"
              required
              labelProps={{ mb: 0 }}
            />
          </Stack>
          {salaryOption.percentage && (
            <>
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"50"}
                InputEndIcon={"%"}
                name="percentage"
                value={inputValue?.percentage}
                onChange={handleInputChange}
              />
              {inputError?.percentage && (
                <Label
                  labelText="Percentage is required"
                  labelProps={{ color: "red" }}
                />
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack
            mb={1}
            gap={0.5}
            direction={"row"}
            alignItems={"center"}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setInputValue((prev) => ({
                ...prev,
                salaryType: "Salary",
                percentage: "", // Clear percentage field
              }));
              setSalaryOption({
                percentage: false,
                salary: true,
                both: false,
              });
            }}
          >
            <img
              width={20}
              src={
                salaryOption.salary
                  ? allIcons.conformIcon
                  : allIcons.checkInactiveCircle
              }
              alt="icon"
            />
            <Label labelText="Salary based" required labelProps={{ mb: 0 }} />
          </Stack>
          {salaryOption.salary && (
            <>
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"4000"}
                InputEndIcon={"SAR"}
                name="salary"
                value={inputValue?.salary}
                onChange={handleInputChange}
              />
              {inputError?.salary && (
                <Label
                  labelText="Salary is required"
                  labelProps={{ color: "red" }}
                />
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack
            mb={1}
            gap={0.5}
            direction={"row"}
            alignItems={"center"}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setInputValue((prev) => ({
                ...prev,
                salaryType: "Both",
              }));
              setSalaryOption({
                percentage: true,
                salary: true,
                both: true,
              });
            }}
          >
            <img
              width={20}
              src={
                salaryOption.both
                  ? allIcons.conformIcon
                  : allIcons.checkInactiveCircle
              }
              alt="icon"
            />
            <Label labelText="Both" required labelProps={{ mb: 0 }} />
          </Stack>
          {/* {salaryOption.both && (
            <>
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"50"}
                InputEndIcon={"%"}
                name="percentage"
                value={inputValue?.percentage}
                onChange={handleInputChange}
              />
              {inputError?.percentage && (
                <Label
                  labelText="Percentage is required"
                  labelProps={{ color: "red" }}
                />
              )}
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"4000"}
                InputEndIcon={"SAR"}
                name="salary"
                value={inputValue?.salary}
                onChange={handleInputChange}
              />
              {inputError?.salary && (
                <Label
                  labelText="Salary is required"
                  labelProps={{ color: "red" }}
                />
              )}
            </>
          )} */}
        </Grid>

        <Grid item xs={12}>
          <Label labelText="Details" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Describe your team member"}
            multiline
            rows={3}
            name={"note"}
            value={inputValue.note}
            onChange={handleInputChange}
          />
          {inputError?.note && (
            <Label
              labelText="Description is required"
              labelProps={{ color: "red" }}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}

export default AddNewMember;
